export const timer = {
  SECONDS_TO_OPEN_CHECKOUT_MODAL: 300, // 5 minutes
  SECONDS_TO_OPEN_SELL_MODAL: 30,
  SECONDS_TO_RELOAD: 30,
  NUMBER_TO_SHOW: 2,
};
